var _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingCustom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 53 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#1976D2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.1,
    dur: "1s",
    repeatCount: "indefinite",
    values: "0;1;0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 6,
    r: 6,
    fill: "#FFA000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.2,
    dur: "1s",
    repeatCount: "indefinite",
    values: "0;1;0"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 6,
    r: 6,
    fill: "#1976D2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.3,
    dur: "1s",
    repeatCount: "indefinite",
    values: "0;1;0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCustom);
export default __webpack_public_path__ + "static/media/loading-custom.407f36fb7398e92e12aa9d6b2a606b0b.svg";
export { ForwardRef as ReactComponent };